import ApproveUser from "./approve-user.container";

export default ApproveUser;
